module.exports = __webpack_public_path__ + "static/media/saratov.74df0143.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Offices/img/saratov.png
// module id = 807
// module chunks = 0